import { FC } from "react";
import { ModalContentProps } from "@inntechcorp/it-design";
import { ThemeProvider } from "styled-components";

import { darkTheme } from "Context/darkTheme"
import { lightTheme } from "Context/lightTheme"
import WebContext from "Context/WebContext"
import PublicSocketContext from "Context/PublicSocketContext"
import PrivateSocketContext from "Context/PrivateSocketContext"
import { ThemeTypes } from "Types/enums";

/**
 * 
 * ### Modal Root Wrapper
 * 
 * Modal'lar portal üzerinde açıldıkları için Context verilerine ulaşamaz.
 * Bu sınıf iletilen context'ler ile modal'lar için yeni context'ler yaratır.
 * Böylece modal'lar site üzerindeki tüm context verilerine ulaşabilir olur.
 * 
 */
const ModalRootWrapper:FC<ModalContentProps> = (props) => {

  const ModalContent = props.modalProps.modal;

  return (
    <div>
      <WebContext.Provider value={props.context}>
        <PublicSocketContext.Provider value={props.context.publicSocket}>
          <PrivateSocketContext.Provider value={props.context.privateSocket}>
            <ThemeProvider
              theme   = {{
                mobile : props.context.isMobile,
                ...(props.context.theme === ThemeTypes.LIGHT ? lightTheme : darkTheme)
              }}
            >
              <ModalContent modalProps={props.modalProps} {...props} />
            </ThemeProvider>
          </PrivateSocketContext.Provider>
        </PublicSocketContext.Provider>
      </WebContext.Provider>
    </div>
  )

}

export default ModalRootWrapper;